﻿(function ($, document, undefined) {
    $(document).ready(function () {
        var $birthdateControl = $('[data-date-input]');
        if ($.fn.flatpickr && $birthdateControl.length) {
            var defaultDate = $birthdateControl.find('input[type=text]').val();
            var dateSettings = {
                dateFormat: "d/m/Y",
                allowInput: true,
                wrap: true,
                onOpen: function (selectedDates, dateStr, instance) {
                    if (dateStr.length == 0) {
                        instance.jumpToDate(new Date(1970, 0, 1));
                        return;
                    }
                    instance.jumpToDate(dateStr);
                    instance.setDate(dateStr);
                }
          };

          console.log(defaultDate);

          if (defaultDate == null || defaultDate == undefined || defaultDate.length == 0) {
                dateSettings.defaultDate = '01/01/1970';
            }

            $birthdateControl.flatpickr(dateSettings);
        }
    });
})(jQuery, document);
